module.exports = __webpack_public_path__ + "static/media/card.3e240fe7.svg";